import React, { useEffect, useState } from 'react';
import { useEffectAsync } from '../../../../helpers';
import apiClient from '../../../../Services/ApiClient';
import { useAppContext } from '../../../../Services/AppContext';

interface NotificationCountProps {
	isSpan?: boolean;
	classes: string;
}

const NotificationCount: React.FC<NotificationCountProps> = ({
	isSpan = false,
	classes,
}) => {
	// @ts-ignore
	const { socket } = useAppContext();
	const [count, setCount] = useState<number>(0);

	const handleLoadData = async () => {
		const {
			data: { meta },
		} = await apiClient.get('/notifications/?unread=1');
		setCount(meta?.count || 0);
	};

	const handleMessageReceived = async (data: any) => {
		if (data.type === 'notification') {
			await handleLoadData();
		}
	};

	const handleNotificationsCountReceived = async (data: any) => {
		if (data.type === 'notification' && data.unread) {
			setCount(data.unread);
		}
	};

	useEffect(() => {
		// @ts-ignore
		socket.on('message', handleMessageReceived);
		// @ts-ignore
		socket.on('notificationsCount', handleNotificationsCountReceived);
		return () => {
			// @ts-ignore
			socket.off('message', handleMessageReceived);
			// @ts-ignore
			socket.off('notificationsCount', handleNotificationsCountReceived);
		};
	}, []);

	useEffectAsync(async () => {
		await handleLoadData();
	}, []);

	if (!count) {
		return <></>;
	}

	return isSpan ? (
		<span className={classes}>{count}</span>
	) : (
		<div className={classes}>{count}</div>
	);
};

export default NotificationCount;
